// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3V0UR","paramInput":"JobSimulator_paramInput__2Lj3T","input":"JobSimulator_input__3w-9J"};